import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ShowIfClientIsGamEnabledDirective } from '@modules/shared/directives/show-if-client-is-gam-enabled.directive';
import { LoaderComponent } from '@modules/shared/loader/loader.component';
import { Store } from '@ngrx/store';
import { Patient } from '@pixacare/domain';
import { Observable, switchMap } from 'rxjs';
import { selectIsGamEnabled } from 'src/app/shared/store/clients/clients.selectors';
import { selectClientCode } from 'src/app/shared/store/router/router.selectors';
import { PatientAvatarComponent } from '../patient-avatar/patient-avatar.component';
import { PatientDataComponent } from '../patient-data/patient-data.component';
import { PatientLinkQuickActionComponent } from '../patient-link-quick-action/patient-link-quick-action.component';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';

@Component({
  selector: 'pxc-patient-search-list',
  templateUrl: './patient-search-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    EmptyStateComponent,
    TranslocoDirective,
    AsyncPipe,
    NgTemplateOutlet,
    LoaderComponent,
    PatientAvatarComponent,
    PatientDataComponent,
    PatientLinkQuickActionComponent,
    ShowIfClientIsGamEnabledDirective,
  ],
  host: {
    class: 'flex flex-col divide-y divide-slate-100',
  },
})
export class PatientSearchListComponent implements OnChanges {
  @Input() patients: Patient[] = null;
  @Output() selectPatient = new EventEmitter<Patient>();

  isGamEnabled$: Observable<boolean>;
  gamLinkedPatients: Patient[] = [];
  pixacarePatients: Patient[] = [];

  private readonly store = inject(Store);

  constructor() {
    this.isGamEnabled$ = this.store
      .select(selectClientCode)
      .pipe(switchMap((clientCode) => this.store.select(selectIsGamEnabled(clientCode))));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.patients) {
      return;
    }

    if (this.patients) {
      this.gamLinkedPatients = [];
      this.pixacarePatients = [];

      for (const patient of this.patients) {
        if (patient.isGamLinked) {
          this.gamLinkedPatients.push(patient);
        } else {
          this.pixacarePatients.push(patient);
        }
      }
    }
  }

  onPatientClick(patient: Patient): void {
    this.selectPatient.emit(patient);
  }
}
